import { OfferType } from '@occc-app/offerValidationService/types';

import { createRouteCreator } from '../CampaignComponents/utils';

export const routeCreator = createRouteCreator(OfferType.Billboard);
